<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Change your Password
      </div>
    </template>

    <div class="rounded-lg white py-6 px-6">
      <v-form ref="form" @submit.prevent="verifyClick">
        <v-text-field
          v-model="password"
          :type="pw_visible ? 'text' : 'password'"
          outlined dense
          label="Current Password"
          :rules="[required]"
          validate-on-blur
          placeholder=" " persistent-placeholder
          autocomplete="off"
          :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="pw_visible = !pw_visible"
        />
        
        <v-text-field
          v-model="new_password"
          :type="pw_visible ? 'text' : 'password'"
          outlined dense
          label="New Password"
          :rules="[required, valid_password]"
          validate-on-blur
          placeholder=" " persistent-placeholder
          autocomplete="off"
          :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="pw_visible = !pw_visible"
        />

        <v-text-field
          v-model="confirmation"
          :type="pw_visible ? 'text' : 'password'"
          outlined dense
          label="Confirm New Password"
          :rules="[required, matches_new_password]"
          validate-on-blur
          placeholder=" " persistent-placeholder
          autocomplete="off"
          :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="pw_visible = !pw_visible"
        />
        <div class="d-flex justify-center">
          <v-btn @click="$router.back()">Cancel</v-btn>
          <v-btn class="ml-4" type="submit" color="primary">Set Password</v-btn>
        </div>
      </v-form>
    </div>
    <ErrorOverlay
      title="Password Error"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import { required, valid_password, matches } from '@/lib/validations'
import { mapActions } from 'vuex'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'YouPasswordView',

  mixins: [ ErrorOverlayMixin ],

  components: { ContentPage },

  data() {
    return {
      pw_visible: false,
      password: '',
      new_password: '',
      confirmation: '',

      // validation rules
      required,
      valid_password,
    }
  },

  computed: {
    // validation rules requiring access to data
    matches_new_password() { return matches(this.new_password, 'New Password') }
  },

  methods: {
    ...mapActions('auth', ['updateMyPassword']),

    async verifyClick() {
      if (this.$refs.form.validate()) {
        
        const result = await this.updateMyPassword({
          password: this.password,
          new_password: this.new_password,
        })

        if (result.ok) {
          this.$router.push({ name: 'you' })
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>
